export enum EFloatingActionsOptions {
  FLAG = 'flag',
  PRIORITY = 'priority',
  STATUS = 'status',
  CUSTOM_FIELDS = 'customFields',
  TAGS = 'tags',
  ASSIGNEES = 'assignees',
}
